import { render, staticRenderFns } from "./CompaniesViewPage.vue?vue&type=template&id=341d0592&scoped=true"
import script from "./CompaniesViewPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesViewPage.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesViewPage.vue?vue&type=style&index=0&id=341d0592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d0592",
  null
  
)

export default component.exports